
import React, { useContext } from 'react';
import { Building, ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useOrganization } from '@/hooks/useOrganization';
import { LanguageProviderContext } from '@/providers/LanguageProvider';

const OrganizationSelector = () => {
  const { currentOrganization, organizations, setCurrentOrganization } = useOrganization();
  const { translator } = useContext(LanguageProviderContext);

  if (organizations.length <= 1) {
    return (
      <div className="flex items-center space-x-2 text-sm text-muted-foreground">
        <Building className="h-4 w-4" />
        <span>{currentOrganization?.name || translator('Home.noOrganizations')}</span>
      </div>
    );
  }

  return (
    <div className="flex items-center space-x-2">
      <Building className="h-4 w-4 text-muted-foreground" />
      <Select
        value={currentOrganization?.id || ''}
        onValueChange={(value) => {
          const org = organizations.find(o => o.id === value);
          if (org) setCurrentOrganization(org);
        }}
      >
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder={translator('Home.selectOrganization')} />
        </SelectTrigger>
        <SelectContent>
          {organizations.map((org) => (
            <SelectItem key={org.id} value={org.id}>
              {org.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default OrganizationSelector;
